<template>
  <div class="row">
    <template v-for="meta in uiMeta">
      <div
        :key="meta.key"
        v-if="!meta.invisible"
        :class="meta._classes && meta._classes.length > 0 ? meta._classes.join(' ') : 'col-12'"
        >
        <div 
          v-if="meta.input_type === 'SelectInput'"
          class="row form-group"
        >
          <label style="text-align: left;" class="col-form-label" v-show="meta.label" :for="'input-'+meta.key">{{meta.label}}</label>
          <v-select 
            :class="(validate(meta.key) === null ? '' : validate(meta.key) ? 'valid' : 'invalid')"
            v-model="tmpData[meta.key]"
            :options="meta.select_options" 
            :reduce="obj => obj.value" 
            :id="'input-'+meta.key"
            @input="debounceValidate(meta.key)"
            :disabled="!editable || !meta.editable"
            :multiple="meta.multiple"
            :placeholder="editable ? meta.placeholder : ''"
          />
          <div v-show="validateFeedback[meta.key]" class="validate-error">{{validateFeedback[meta.key]}}</div>
        </div>
        <div
          v-else-if="meta.input_type === 'PasswordInput'"
          class="row form-group">
          <label class="col-form-label" v-show="meta.label" :for="'input-'+meta.key">{{meta.label}}</label>
          <input 
            type="password"
            :class="'form-control ' + (validate(meta.key) === null ? '' : validate(meta.key) ? 'valid' : 'invalid')"
            :id="'input-'+meta.key"
            :placeholder="editable ? meta.placeholder : ''"
            @input="debounceValidate(meta.key)"
            v-model="tmpData[meta.key]"
            :disabled="!editable || !meta.editable"
          >
          <div v-show="validateFeedback[meta.key]" class="validate-error">{{validateFeedback[meta.key]}}</div>
        </div>
        <div
          v-else-if="meta.input_type === 'DateInput'"
          class="row form-group">
          <label class="col-form-label" v-show="meta.label" :for="'input-'+meta.key">{{meta.label}}</label>
          <date-picker
            :class="validate(meta.key) === null ? '' : validate(meta.key) ? 'valid' : 'invalid'"
            style="width: 100%;"
            v-model="tmpData[meta.key]" 
            valueType="format"
            :placeholder="editable ? meta.placeholder : ''"
            :id="'input-'+meta.key"
            @change="debounceValidate(meta.key)"
            :disabled="!editable || !meta.editable"
            >
          </date-picker>
          <div v-show="validateFeedback[meta.key]"  class="validate-error">{{validateFeedback[meta.key]}}</div>
        </div>
        <div
          v-else-if="meta.input_type === 'DateTimeInput'"
          class="row form-group">
          <label class="col-form-label" v-show="meta.label" :for="'input-'+meta.key">{{meta.label}}</label>
          <date-picker
            :class="validate(meta.key) === null ? '' : validate(meta.key) ? 'valid' : 'invalid'"
            style="width: 100%;"
            v-model="tmpData[meta.key]" 
            type="datetime"
            valueType="format"
            :format="dateTimeFormat"
            :placeholder="editable ? meta.placeholder : ''"
            :id="'input-'+meta.key"
            @change="debounceValidate(meta.key)"
            :disabled="!editable || !meta.editable"
            >
          </date-picker>
          <div v-show="validateFeedback[meta.key]"  class="validate-error">{{validateFeedback[meta.key]}}</div>
        </div>
        <div
          v-else-if="meta.input_type === 'NumberInput'"
          class="row form-group">
          <label class="col-form-label" v-show="meta.label" :for="'input-'+meta.key">{{meta.label}}</label>
          <input 
            type="number"
            :class="'form-control ' + (validate(meta.key) === null ? '' : validate(meta.key) ? 'valid' : 'invalid')"
            :id="'input-'+meta.key"
            :placeholder="editable ? meta.placeholder : ''"
            @input="debounceValidate(meta.key)"
            v-model="tmpData[meta.key]"
            :disabled="!editable || !meta.editable"
          >
          <div v-show="validateFeedback[meta.key]" class="validate-error">{{validateFeedback[meta.key]}}</div>
        </div>
        <div
          v-else-if="meta.input_type === 'MultiLineInput'"
          class="row form-group">
          <label class="col-form-label" v-show="meta.label" :for="'input-'+meta.key">{{meta.label}}</label>
          <textarea 
            :class="'form-control ' + (validate(meta.key) === null ? '' : validate(meta.key) ? 'valid' : 'invalid')"
            @input="debounceValidate(meta.key)"
            :placeholder="editable ? meta.placeholder : ''"
            v-model="tmpData[meta.key]"
            :disabled="!editable || !meta.editable"
            rows="6"
          ></textarea>
          <div v-show="validateFeedback[meta.key]" class="validate-error">{{validateFeedback[meta.key]}}</div>
        </div>
        <div
          v-else-if="meta.input_type === 'RadioInput'"
          class="row form-group">
          <label class="col-form-label" v-show="meta.label" :for="'input-'+meta.key">{{meta.label}}</label>
          <div class="col-12" style="text-align: left; margin-top: 5px;">
            <div 
              class="form-check form-check-inline"
              v-for="select_option in meta.select_options"
              :key="meta.key + '-' + select_option.value"
            >
              <input
                class="form-check-input" 
                type="radio" 
                :name="'input-'+meta.key"
                v-model="tmpData[meta.key]"
                :disabled="!editable || !meta.editable"
                :value="select_option.value" 
                @change="debounceValidate(meta.key)"
              >
              <label class="form-check-label">
                {{select_option.label}}
                <span
                  v-if="select_option.description"
                  data-toggle="tooltip" 
                  data-placement="top"
                  :title="select_option.description"
                  style="cursor: pointer;"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor" class="bi bi-question-circle-fill" viewBox="0 0 16 16">
                    <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.496 6.033h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286a.237.237 0 0 0 .241.247zm2.325 6.443c.61 0 1.029-.394 1.029-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94 0 .533.425.927 1.01.927z"/>
                  </svg>
                </span>
              </label>
            </div>
          </div>
          <div class="col-12" style="color: #768192; " v-show="editable && meta.placeholder && !tmpData[meta.key]">{{editable ? meta.placeholder : ''}}</div>
          <div class="col-12 validate-error" v-show="validateFeedback[meta.key]">{{validateFeedback[meta.key]}}</div>
        </div>
        <div
          v-else
          class="row form-group">
          <label class="col-form-label" v-show="meta.label" :for="'input-'+meta.key">{{meta.label}}</label>
          <input 
            type="input"
            :class="'form-control ' + (validate(meta.key) === null ? '' : validate(meta.key) ? 'valid' : 'invalid')"
            :id="'input-'+meta.key"
            :placeholder="editable ? meta.placeholder : ''"
            @input="debounceValidate(meta.key)"
            v-model="tmpData[meta.key]"
            :disabled="!editable || !meta.editable"
          >
          <div v-show="validateFeedback[meta.key]" class="validate-error">{{validateFeedback[meta.key]}}</div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import $ from 'jquery'
import vSelect from 'vue-select'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import 'vue-select/dist/vue-select.css'
// Use Chinese
import 'vue2-datepicker/locale/zh-cn'

const uiMetaFieldsFragment = `
    fragment uiMetaFields on VoUiMeta {
      _classes
      input_type
      key
      label
      placeholder
      select_options {
        label
        value
        description
      }
      select_allow_new_input
      editable
      validate_dep_keys
      default_value
      multiple
      invisible
      call_refresh_on_value_change
    }
`

export default {
  name: 'ValidateForm',
  components: {
    DatePicker,
    vSelect,
  },
  props: {
    voName: {
      type: String,
      required: true,
    },
    data: {
      type: Object,
      default() { return {} },
    },
    editable: {
      type: Boolean,
      default() { return true },
    },
  },
  data() {
    return {
      dateTimeFormat: {
        // Date to String
        stringify: (date) => {
          return date ? date.format("yyyy-MM-dd hh:mm:ss") : ''
        },
        // String to Date
        parse: (value) => {
          return value ? new Date(value) : null
        }
      },
      validateFeedback: {},
      debounceFunc: {},
      tmpData: {},
      uiMeta: [],
      uiMetaRefreshKey: '',
      isUiMetaReady: false,
    }
  },
  computed: {
    ...mapState({
      errors: state => state.page.errors,
    }),
  },
  methods: {
    ...mapActions({
      'onQuery': 'page/onQuery',
    }),
    onDatetimeChange () {
      this.emitDataOnChange()
    },
    debounceValidate(fieldName) {
      if (this.voName) {
        this.emitDataOnChange()
        if (this.debounceFunc[fieldName]) clearTimeout(this.debounceFunc[fieldName])
        this.debounceFunc[fieldName] = setTimeout(() => {
          const valueObject = {}
          valueObject[fieldName] = this.tmpData[fieldName]
          let needToRefresh = false
          for (const element of this.uiMeta) {
            if (element.key === fieldName) {
              if (element.validate_dep_keys) {
                for (const depkey of element.validate_dep_keys) {
                  valueObject[depkey] = this.tmpData[depkey]
                }
              }
              needToRefresh = element.call_refresh_on_value_change
              break
            }
          }
          let query = null
          if (needToRefresh) {
            query = {
              query: `
                ${uiMetaFieldsFragment}
                query($voName: String!, $fieldName: String!, $inputForValidate: JSON!, $inputForUpdate: JSON!){
                  ValidateField(fieldName: $fieldName, input: $inputForValidate, voName: $voName)
                  GetUpdatedUiMetaAndData(name: $voName, input: $inputForUpdate){
                    data
                    ui_meta {
                      ...uiMetaFields
                    }
                  }
                }
              `,
              variables: {
                voName: this.voName,
                fieldName: fieldName,
                inputForValidate: valueObject,
                inputForUpdate: this.tmpData
              },
            }
          } else {
            query = {
              query: `
                query($voName: String!, $fieldName: String!, $input: JSON!){
                  ValidateField(fieldName: $fieldName, input: $input, voName: $voName)
                }
              `,
              variables: {
                voName: this.voName,
                fieldName: fieldName,
                input: valueObject,
              },
            }
          }
          this.onQuery(query).then(resp => {
            if (needToRefresh && resp.GetUpdatedUiMetaAndData) {
              this.uiMeta = resp.GetUpdatedUiMetaAndData.ui_meta
              this.tmpData = resp.GetUpdatedUiMetaAndData.data
              this.uiMetaRefreshKey = this.generateUiMetaRefreshKey(this.tmpData)
            }
            Object.keys(resp.ValidateField).forEach(key => {
              this.validateFeedback[key] = resp.ValidateField[key].join(',')
            })
            this.$forceUpdate()
            Object.keys(this.validateFeedback).forEach(key => {
              if (this.validateFeedback[key]) {
                return
              }
            })
          })
        }, 1000)
      }
    },
    emitDataOnChange() {
      const obj = {}
      for (const meta of this.uiMeta) {
        if (meta.key in this.tmpData) {
          obj[meta.key] = this.tmpData[meta.key]
        }
      }
      this.$emit('changed', obj)
    },
    validate (fieldName) {
      if (this.validateFeedback[fieldName] === null || this.validateFeedback[fieldName] == undefined) {
        return null
      } else {
        return !this.validateFeedback[fieldName]
      }
    },
    parseDataWithDefaultValue(data) {
      const obj = {}
      for (const element of this.uiMeta) {
        if (element.default_value) {
          obj[element.key] = element.default_value
        }
      }
      return {
        ...obj,
        ...data,
      }
    },
    asyncQueryUpdatedUiMetaAndData(voName, data) {
      return this.onQuery({
        query: `
          ${uiMetaFieldsFragment}
          query($name: String!, $input: JSON!){
            GetUpdatedUiMetaAndData(name: $name, input: $input){
              data
              ui_meta {
                ...uiMetaFields
              }
            }
          }
        `,
        variables: {
          name: voName,
          input: data,
        },
      })
    },
    generateUiMetaRefreshKey(currentData) {
      const keys = []
      for (const element of this.uiMeta) {
        if (element.call_refresh_on_value_change) {
          keys.push(currentData[element.key] ? currentData[element.key] : '')
        }
      }
      return keys.join(':')
    },
  },
  created () {
    this.asyncQueryUpdatedUiMetaAndData(this.voName, this.data)
      .then(resp => {
        this.uiMeta = resp.GetUpdatedUiMetaAndData.ui_meta
        this.tmpData = this.parseDataWithDefaultValue(resp.GetUpdatedUiMetaAndData.data)
        this.uiMetaRefreshKey = this.generateUiMetaRefreshKey(this.tmpData)
        this.$emit('init', this.tmpData)
        this.isUiMetaReady = true
      })
  },
  updated () {
    $('[data-toggle="tooltip"]').tooltip()
  },
  watch: {
    data (newVal) {
      // Wait to fetch uiMeta
      const $this = this
      function checkUiMetaLock() {
        if ($this.isUiMetaReady) {
          const newUiMetaRefreshKey = $this.generateUiMetaRefreshKey(newVal)
          if (newUiMetaRefreshKey !== $this.uiMetaRefreshKey) {
            $this.isUiMetaReady = false
            $this.asyncQueryUpdatedUiMetaAndData($this.voName, newVal)
              .then(resp => {
                $this.uiMeta = resp.GetUpdatedUiMetaAndData.ui_meta
                $this.tmpData = $this.parseDataWithDefaultValue(resp.GetUpdatedUiMetaAndData.data)
                $this.uiMetaRefreshKey = $this.generateUiMetaRefreshKey(newVal)
                $this.isUiMetaReady = true
              })
          } else {
            $this.tmpData = $this.parseDataWithDefaultValue(newVal)
          }
        } else {
          setTimeout(checkUiMetaLock, 100)
        }
      }
      checkUiMetaLock()
    },
    errors (newVal) {
      const tmpValidateFeedback = {}
      for (const key in newVal.validateFeedback) {
        tmpValidateFeedback[key] = newVal.validateFeedback[key].join(',')
      }
      this.validateFeedback = tmpValidateFeedback
    }
  }
}
</script>

<style>
.mx-input:disabled, .mx-input.disabled, .form-control:disabled, .form-control[readonly] {
  background-color: rgb(250, 250, 250);
  cursor: not-allowed;
}
.validate-error {
  color: #e55353; 
  font-size: 11px;
  margin-top: 5px;
}
.v-select {
  width: 100%;
  background-color: white;
}
.v-select .vs__search {
  height: 24px;
  color: #768192;
}
.v-select .vs__selected {
  color: #768192;
}
.invalid {
  border: 0.01em solid #e55353;
  border-radius: 5px;
  background-repeat: no-repeat;
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
.invalid:focus {
  border: 0.01em solid #e55353;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 8px #e55353;
}
.valid {
  border: 0.01em solid #2eb85c;
  border-radius: 5px;
  background-repeat: no-repeat;
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
.valid:focus {
  border: 0.01em solid #2eb85c;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 8px #2eb85c;
}

.mx-input {
  color: #768192 !important;
  background-color: #fff!important;
}
.mx-input:hover {
  border-color: #eee !important;
}
.mx-input:focus {
  color: #768192 !important;
  background-color: #fff !important;
  border-color: #958bef !important;
  outline: 0 !important;
  -webkit-box-shadow: 0 0 0 0.2rem rgba(50, 31, 219, 0.25) !important;
  box-shadow: 0 0 0 0.2rem rgba(50, 31, 219, 0.25) !important;
}

.vs__clear:disabled {
  display: none;
}

.mx-input:disabled, .mx-input.disabled {
    color: #768192 !important;
}
</style>